import styled from 'styled-components/macro';

export const Count = styled.span`
    display: block;
    float: right;
    font-weight: normal;
`;

export default Count;
